import * as React from "react";
import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { DragDropFileUploadProps, DragDropFileUploadState, DragDropFileUploadHandler } from './dragdropfileuploadcomponent';
import { DragDropFileUploadCSSStyleImpl } from './dragdropfileuploadcss';
import { FileUploadStatus } from '../fileupload/fileuploadcomponent';
import { Strings } from '../../../utils/resources/strings';
import './loader.css';
//import { PreviewPlayerCSSStyleImpl } from '../../components/home/preview/previewplayercss';
//import { PreviewComponentState } from '../../components/home/preview/previewcomponent';
//import { ButtonComponent } from '../button/buttoncomponent';
//import { ButtonCSSStyleImpl } from '../button/buttoncss';
import { PlayerWithSeekbarComponent } from '../player/playerwithseekbar/playerwithseekbarcomponent';
import { PlayerWithSeekbarComponentCSSStyleImpl } from '../player/playerwithseekbar/playerwithseekbarcss';
import { ButtonComponent } from '../button/buttoncomponent';
import { ReplaceButtonCSSStyleImpl } from './replacebuttoncss';
import { RadialProgressBarComponent } from '../radialprogressbar/radialprogressbarcomponent';
import { RadialProgressBarCSSStyleImpl } from '../radialprogressbar/radialprogressbarcss';
// import { RadialProgressBarComponent } from '../radialprogressbar/radialprogressbarcomponent';

export class DragDropFileUploadView extends UIComponentViewImpl<UIDataModel>
{
    private fileUploadElement: HTMLInputElement;
    private playerComponent: PlayerWithSeekbarComponent | null;
    private files: any;

    bindHandlers()
    {
       this.onSelectFile = this.onSelectFile.bind(this);
       this.onUploadButtonClick = this.onUploadButtonClick.bind(this);
       this.onDragOver = this.onDragOver.bind(this);
       this.onDragLeave = this.onDragLeave.bind(this);
       this.onDrop = this.onDrop.bind(this);
       this.onReupload = this.onReupload.bind(this);
       this.onPlayClicked = this.onPlayClicked.bind(this);
       this.onStopClicked = this.onStopClicked.bind(this);
    }

    draw(uiProps: DragDropFileUploadProps, uiState: DragDropFileUploadState, cssStyle: DragDropFileUploadCSSStyleImpl): JSX.Element {
        super.draw(uiProps, uiState, cssStyle);

        return (
            <>
                {
                    uiState.fileUploadStatus === FileUploadStatus.FILE_UPLOAD && this.getFileUploadCSS(uiProps, uiState, cssStyle)
                }
                {
                    uiState.fileUploadStatus === FileUploadStatus.FILE_PREVIEW && this.getFilePreviewCSS(uiProps, uiState, cssStyle)
                }
                {
                    uiState.fileUploadStatus === FileUploadStatus.FILE_UPLOADING && this.getFileUploadingCSS(uiProps, uiState, cssStyle)
                }
                {
                    uiState.fileUploadStatus === FileUploadStatus.FILE_UPLOADED && this.getFileUploadedCSS(uiProps, uiState, cssStyle)
                }
              </>  
           );
    }

    getUIProps(): DragDropFileUploadProps {
        return super.getUIProps() as DragDropFileUploadProps;
    }

    validate(): boolean {
        if (this.files !== null && this.files.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }

    getData(): any {
        if (this.files !== null) {
            return this.files[0];
        }
    }

    clearData() {
        this.fileUploadElement.value = '';
    }

    onUploadButtonClick() {
        this.fileUploadElement.click();
    }

    onPlayComplete(): void 
    {
        this.playerComponent !== null && this.playerComponent.onPlayComplete();
    }

    onPlayStop(): void {
        this.playerComponent !== null && this.playerComponent.onPlayStop();
    }

    private onSelectFile() {
        if(this.fileUploadElement.files !== null && this.fileUploadElement.files.length > 0)
        {
            this.files = this.fileUploadElement.files;
            (this.getUIComponentHandler() as DragDropFileUploadHandler).onSelectFile(this.fileUploadElement.files[0].name);
        }
    }

    private getFileUploadCSS(uiProps: DragDropFileUploadProps, uiState: DragDropFileUploadState, cssStyle: DragDropFileUploadCSSStyleImpl) {
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
            <div onDragOver={this.onDragOver} onDragLeave={this.onDragLeave} onDrop={this.onDrop} style={{marginLeft: "25px", marginRight: "25px", paddingTop: "20px"}}>
                <input style={cssStyle.getInputCSSStyle()} ref={(item:any)=>this.fileUploadElement = item} onChange={this.onSelectFile} accept={this.getContext().getProperty().getTuneFileType()} multiple={false} type="file"/>
                    <div style={{height: "70px", width: "31.5px", float: "left"}}>
                    <img src={this.getUIProps().context.getResources().getImage("folder.svg")} style={cssStyle.getUploadIconCSSStyle()}/>
                    </div>
                    <div style={{display: "flex", flexFlow: "row wrap", paddingLeft: "16px", paddingRight: "16px"}}>
                        <label style={cssStyle.getDropFileTextCSSStyle()} onClick={this.onUploadButtonClick}>
                                {uiProps.context.getResources().getString(Strings.drop_your_file_here)}
                        </label>
                        <label style={cssStyle.getBrowseButtonStyle()} onClick={this.onUploadButtonClick}>
                            {uiProps.context.getResources().getString(Strings.browse)}
                        </label>
                    </div>
                    <div style={{display: "flex", flexFlow: "row wrap", paddingLeft: "16px", paddingRight: "16px"}}>
                        <label style={cssStyle.getSupportMp3TextCSSStyle()}>
                                {uiProps.context.getResources().getString(Strings.support_mp3_file)}
                        </label>
                    </div>
                    </div>
        </div>);    
    }

    private getFilePreviewCSS(uiProps: DragDropFileUploadProps, uiState: DragDropFileUploadState, cssStyle: DragDropFileUploadCSSStyleImpl)
    {
        return (
            <div style={cssStyle.getPreviewCSSStyle()}>
            <div style={{marginLeft: "20px", marginRight: "20px", paddingTop: "5px", paddingBottom: "5px"}}>
                <label style={cssStyle.getFilenameCSSStyle()}>
                    {
                        uiState.fileName
                    }
                </label>
                <div style={cssStyle.getPlayerReplaceButtonDivCSSStyle()}>
                    <PlayerWithSeekbarComponent ref={(item: any)=>{this.playerComponent = item;}} playIconName={"play_pink.svg"} pauseIconName={"pause_pink.svg"} playerCSSStyle={new PlayerWithSeekbarComponentCSSStyleImpl(uiProps.context)} isPlaying={false} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} context={uiProps.context} />
                    <div style={cssStyle.getReplaceButtonCSSStyle()}>
                        <ButtonComponent onClick={this.onReupload} style={new ReplaceButtonCSSStyleImpl(uiProps.context)} context={uiProps.context} label={uiProps.context.getResources().getString(Strings.replace)} />
                    </div>
                </div>
                </div>
            </div>);
    }

    private onPlayClicked(): void
    {
        if(this.files !== null)
        {
            this.getContext().getPlayerManager().startPlay(URL.createObjectURL(this.files[0]), this);
        }
    }

    private onStopClicked(): void
    {
        this.getContext().getPlayerManager().stopPlay();
    }

    private getFileUploadingCSS(uiProps: DragDropFileUploadProps, uiState: DragDropFileUploadState, cssStyle: DragDropFileUploadCSSStyleImpl) {
        return (
            <div style={cssStyle.getPreviewCSSStyle()}>
            <div style={{marginLeft: "25px", marginRight: "25px", paddingTop: "25px", display: "flex", flexFlow: "row wrap", }}>
                    {/* <div style={cssStyle.getLoaderCSSStyle()}/> */}
                    <div style={{width:'36px',height:'36px',marginRight:'10px'}}>
                    <RadialProgressBarComponent children={''} cssStyle={new RadialProgressBarCSSStyleImpl(this.getContext())} id={"doItYourself"} percentage={uiState.uploadProgressStatus} context={this.getContext()}/>

                    </div>
                     <div style={{width:'100px',height:'40px',textAlign:'left'}}>
                         <label style={{fontFamily:uiProps.context.getResources().getFontFamily(), width:"100%",height:'20px',lineHeight:"20px",fontSize:'14px',color:'#FFFFFF', marginBottom:"0px"}}>
                                {uiProps.context.getResources().getString(Strings.uploading)}                         </label>
                         <label style={{fontFamily:uiProps.context.getResources().getFontFamily(), width:"100%",height:'20px',lineHeight:"20px",fontSize:'12px',color:'#FFCB08', marginBottom:"0px"}}>
                             {this.getPercentage(uiState)}
                         </label>
                     </div>
                    {/* <label style={cssStyle.getUploadingTextCSSStyle()}>
                            {uiProps.context.getResources().getString(Strings.uploading)}
                            
                    </label> */}
                   
                    
            </div>
        </div>);     
    }

    private getPercentage(state:DragDropFileUploadState):string
    {
        return state.uploadProgressStatus+'%';
    }
    private getFileUploadedCSS(uiProps: DragDropFileUploadProps, uiState: DragDropFileUploadState, cssStyle: DragDropFileUploadCSSStyleImpl) {
        return (
            <div style={cssStyle.getPreviewCSSStyle()}>
            <div style={{marginLeft: "25px", marginRight: "25px", paddingTop: "25px", display: "flex", flexFlow: "row wrap", }}>
                     <img src={this.getUIProps().context.getResources().getImage("successful.svg")} style={cssStyle.getSuccessFullIconCSSStyle()}/>
                    <label style={cssStyle.getSuccessfullTextCSSStyle()}>
                            {uiProps.context.getResources().getString(Strings.successfull)}
                    </label>
                </div>
            </div>);      
    }

    private onDragOver(e: any) 
    {
        console.log("onDropOver");
        e.stopPropagation();
        e.preventDefault();
        e.target.className = e.type;
    }

    private onDragLeave(e: any) 
    {
        console.log("onDropLeave");
        e.stopPropagation();
        e.preventDefault();
        e.target.className = e.type;
    }

    private onDrop(e: any) 
    {
        console.log("onDrop");
        e.target.className = e.type;
        e.stopPropagation();
        e.preventDefault();

        if(this.isFileTypeMP3(e.dataTransfer.files))
        {
            if(this.fileUploadElement !== null)
            {
                this.files = e.dataTransfer.files;

                (this.getUIComponentHandler() as DragDropFileUploadHandler).onSelectFile(this.files[0].name);
            }
        }
        else
        {
            (this.getUIProps() as DragDropFileUploadProps).invalidFile(this.getUIProps().context.getResources().getString(Strings.invalid_file_type));
        }
    }

    private isFileTypeMP3(files: any) 
    {
        var fileExt = files[0].name;
        fileExt = fileExt.substring(fileExt.lastIndexOf('.'));

        let fileTypes = this.getContext().getProperty().getTuneFileType().split(",");

        let isExist = fileTypes.findIndex((type: string) =>
        {
            return fileExt === type ;
        });
        return isExist === -1 ? false : true;
    }

    private onReupload()
    {
        (this.getUIComponentHandler() as DragDropFileUploadHandler).onReupload();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dragdropfile/dragdropfileuploadview.tsx